'use strict';

import dialog from './dialog';
import product from './pages/product';
import util from './util';
import modalExport from './modal';
const modal = modalExport.global;
import _ from 'lodash-es';


var makeUrl = function (url, source, productListID) {
    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }
    return url;
};

var removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

function bindQvButton($qvButton) {
	$qvButton.on("click", function (e) {
		var $this = $(this);
        var url = $this.attr("href");
        if( !util.isMobile() && url ) {
            e.preventDefault();
            quickview.show({
                url: url,
                source: 'quickview',
                callback: function() {
                    require('./pages/product/image')()
                    require('./pages/product/variant')();
                }
            });
        }
	});
}

var quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });
    },
    
    initializeButton : function (container, target) {
		// quick view button
		$(container).on("mouseenter", target, function (e) {
			$('#quickviewbutton').remove(); // remove any previous quickview
			var $qvButton = $("<span id='quickviewbutton' class='red-button'>Shop</span>");
			bindQvButton($qvButton);
			var link = $(this).children("a:first");
			$(this).find('.quickview').append(
				$qvButton.attr({
					"href" : link.attr("href"),
					"title" : link.attr("title")
				})
			);
		});
	},
	bindQvButton : bindQvButton,
    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options, addNewCustomClass) {
        var url = makeUrl(options.url, options.source, options.productlistid);
        if(typeof options.callback === 'function') {
        	modal.setCallback(options.callback);
        }
        else{
        	/*If No call back is set then initiate variant and image js functions so that variation changes works on quickview*/
        	modal.setCallback(
				function() {
	                require('./pages/product/image')()
	                require('./pages/product/variant')();
	            }	
        	);
        }
        
    	modal.addCustomClass(`edit-modal quickview-modal ${addNewCustomClass}`); // To custom class for quickview modal
        modal.renderByUrl(url);
    },
    
    showmini: function (options) {    	
        var url = makeUrl(options.url, options.source, options.productlistid);
         url = util.appendParamToURL(url, 'format', 'ajax');
         var container = options.qvContainer;
          $.get(url,function(data){ 
        	  container.html(data);
        	  container.append("<i class='icon-close'></i>");
        	  return container;
	          }).done(options.callback); 
   },
   
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

export default quickview;
